export const TERMS_CONTENT = {
  'objeto-alcance': [
    {
      type: 'paragraph',
      text:
        'El presente documento regula el uso del canal digital dispuesto por {companyName} para la recepción, radicación, análisis, seguimiento y respuesta de:',
    },
    {
      type: 'list',
      items: [
        'Peticiones.',
        'Quejas.',
        'Reclamos.',
        'Sugerencias.',
        'Felicitaciones.',
        'Recursos relacionados con una decisión, cuando procedan.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Estas condiciones aplican a usuarios, suscriptores, clientes, representantes, proveedores y demás personas que utilicen el formulario.',
    },
    {
      type: 'paragraph',
      text:
        'Cuando una sugerencia o felicitación contenga elementos propios de una petición, queja o reclamo, podrá ser reclasificada para garantizar su correcta atención.',
    },
  ],

  aceptacion: [
    {
      type: 'paragraph',
      text:
        'Antes de enviar el formulario, el usuario deberá leer y aceptar estas condiciones.',
    },
    {
      type: 'paragraph',
      text:
        'Al seleccionar la casilla correspondiente, el usuario declara que:',
    },
    {
      type: 'list',
      items: [
        'Conoció el propósito del canal.',
        'Comprendió las condiciones de presentación y gestión de la solicitud.',
        'Suministra la información de manera libre y consciente.',
        'Autoriza el tratamiento de los datos necesarios para gestionar el trámite.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'La aceptación de estas condiciones no limita los derechos legales, contractuales o regulatorios del usuario.',
    },
  ],

  clasificacion: [
    {
      type: 'paragraph',
      text:
        'Las solicitudes podrán clasificarse de acuerdo con su contenido y finalidad.',
    },
    {
      type: 'requestTypes',
    },
  ],

  presentacion: [
    {
      type: 'paragraph',
      text:
        'Para facilitar una atención clara y efectiva, el usuario deberá:',
    },
    {
      type: 'list',
      items: [
        'Seleccionar el tipo de solicitud que corresponda a su caso.',
        'Suministrar información verdadera, comprensible y actualizada.',
        'Describir los hechos de manera clara, respetuosa y ordenada.',
        'Registrar un medio de contacto válido.',
        'Aportar los datos del servicio, cuenta, contrato o suscripción cuando sean necesarios.',
        'Adjuntar únicamente documentos relacionados con la solicitud.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Cuando la información sea insuficiente para gestionar el trámite, podrá solicitarse al usuario que complete o aclare los datos suministrados.',
    },
    {
      type: 'paragraph',
      text:
        'El usuario deberá evitar incluir contraseñas, claves bancarias, números completos de tarjetas u otra información financiera reservada.',
    },
  ],

  radicacion: [
    {
      type: 'paragraph',
      text:
        'La solicitud se entenderá recibida cuando el sistema confirme su envío exitoso.',
    },
    {
      type: 'paragraph',
      text:
        'Una vez registrada, la plataforma podrá generar un número de radicado para identificar el trámite y facilitar su seguimiento.',
    },
    {
      type: 'paragraph',
      text:
        'El usuario deberá conservar este número para:',
    },
    {
      type: 'list',
      items: [
        'Identificar la solicitud presentada.',
        'Consultar su estado.',
        'Aportar información adicional.',
        'Relacionar comunicaciones posteriores.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Si el sistema presenta un error y no genera confirmación, el usuario podrá intentar nuevamente o utilizar otro canal oficial de atención.',
    },
  ],

  'gestion-respuesta': [
    {
      type: 'paragraph',
      text:
        'Las solicitudes serán atendidas dentro de los términos definidos por la normatividad y regulación aplicables.',
    },
    {
      type: 'paragraph',
      text:
        'Cuando resulte necesario realizar verificaciones, solicitar documentos, practicar pruebas o complementar información, se informará al usuario mediante el medio de contacto registrado.',
    },
    {
      type: 'paragraph',
      text:
        'La respuesta podrá contener:',
    },
    {
      type: 'list',
      items: [
        'Identificación de la solicitud.',
        'Resumen de los hechos planteados.',
        'Verificaciones realizadas.',
        'Fundamentos de la decisión.',
        'Solución, orientación o respuesta correspondiente.',
        'Información sobre recursos, cuando procedan.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'La respuesta deberá ser clara, completa, comprensible y relacionada con el contenido de la solicitud.',
    },
  ],

  comunicaciones: [
    {
      type: 'paragraph',
      text:
        'El usuario deberá registrar un medio válido para recibir:',
    },
    {
      type: 'list',
      items: [
        'Confirmaciones de radicación.',
        'Solicitudes de aclaración.',
        'Comunicaciones sobre el trámite.',
        'Respuestas y decisiones.',
        'Información relacionada con recursos, cuando procedan.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Las comunicaciones podrán enviarse al correo electrónico, número telefónico, dirección física o medio seleccionado por el usuario.',
    },
    {
      type: 'paragraph',
      text:
        'El usuario es responsable de mantener actualizada su información de contacto y revisar el medio escogido.',
    },
  ],

  'datos-personales': [
    {
      type: 'paragraph',
      text:
        'Los datos recolectados mediante el formulario serán utilizados para:',
    },
    {
      type: 'list',
      items: [
        'Identificar al solicitante cuando sea necesario.',
        'Radicar, clasificar y gestionar la PQRSF.',
        'Verificar la información y los hechos reportados.',
        'Contactar al usuario.',
        'Comunicar respuestas y decisiones.',
        'Conservar evidencia de la atención.',
        'Cumplir obligaciones legales, regulatorias y contractuales.',
        'Elaborar estadísticas y mejorar los procesos de atención.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Según la naturaleza del trámite, podrán recolectarse datos de identificación, contacto, información del servicio, descripción de los hechos, datos técnicos y documentos adjuntos.',
    },
    {
      type: 'paragraph',
      text:
        'El titular podrá ejercer sus derechos de conocer, actualizar, rectificar y solicitar la supresión de sus datos cuando legalmente proceda.',
    },
    {
      type: 'alert',
      icon: 'fa-user-shield',
      text:
        'La autorización necesaria para gestionar la PQRSF no constituye una autorización automática para enviar publicidad, promociones o comunicaciones comerciales.',
    },
  ],

  'datos-especiales': [
    {
      type: 'paragraph',
      text:
        'El usuario deberá abstenerse de suministrar datos sensibles que no sean necesarios para resolver su solicitud.',
    },
    {
      type: 'paragraph',
      text:
        'Cuando resulte indispensable tratar este tipo de información, se aplicarán medidas reforzadas de seguridad, confidencialidad y acceso restringido.',
    },
    {
      type: 'paragraph',
      text:
        'La información de niños, niñas y adolescentes será tratada respetando sus derechos prevalentes y con la autorización del representante legal cuando corresponda.',
    },
  ],

  archivos: [
    {
      type: 'paragraph',
      text:
        'Los archivos aportados deberán ser legibles, pertinentes y estar directamente relacionados con la solicitud.',
    },
    {
      type: 'paragraph',
      text:
        'La plataforma podrá limitar:',
    },
    {
      type: 'list',
      items: [
        'La cantidad de archivos.',
        'El tamaño máximo permitido.',
        'Los formatos admitidos.',
        'Los documentos protegidos con contraseña.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Podrán rechazarse archivos corruptos, ejecutables, maliciosos o que representen un riesgo para la seguridad de la plataforma.',
    },
    {
      type: 'paragraph',
      text:
        'La recepción de un documento no implica el reconocimiento automático de su autenticidad, validez o contenido.',
    },
  ],

  seguridad: [
    {
      type: 'paragraph',
      text:
        '{companyName} aplicará medidas administrativas, técnicas y organizacionales razonables para proteger la información contra:',
    },
    {
      type: 'list',
      items: [
        'Pérdida.',
        'Alteración.',
        'Consulta no autorizada.',
        'Uso indebido.',
        'Divulgación no permitida.',
        'Acceso fraudulento.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'El acceso a la información estará limitado al personal, contratistas, encargados o proveedores que deban intervenir en la gestión y estén sujetos a obligaciones de confidencialidad.',
    },
  ],

  disponibilidad: [
    {
      type: 'paragraph',
      text:
        'El formulario podrá presentar interrupciones temporales debido a:',
    },
    {
      type: 'list',
      items: [
        'Mantenimiento programado.',
        'Actualizaciones de la plataforma.',
        'Fallas de conectividad.',
        'Incidentes técnicos.',
        'Eventos fuera del control razonable de la organización.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Cuando el canal no se encuentre disponible, el usuario podrá utilizar los demás medios oficiales habilitados por {companyName}.',
    },
    {
      type: 'paragraph',
      text:
        'Una falla técnica no elimina ni limita el derecho a presentar la solicitud mediante otro canal disponible.',
    },
  ],

  'uso-adecuado': [
    {
      type: 'paragraph',
      text:
        'No está permitido utilizar este canal para:',
    },
    {
      type: 'list',
      items: [
        'Suplantar la identidad de otra persona.',
        'Presentar información deliberadamente falsa.',
        'Enviar amenazas, contenidos ilícitos o expresiones discriminatorias.',
        'Introducir programas o archivos maliciosos.',
        'Intentar acceder sin autorización a los sistemas.',
        'Realizar envíos automatizados o repetitivos que afecten el funcionamiento del canal.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Las medidas de seguridad adoptadas frente a un uso indebido no impedirán el ejercicio legítimo de los derechos del usuario.',
    },
  ],

  actualizacion: [
    {
      type: 'paragraph',
      text:
        'Estas condiciones podrán actualizarse cuando cambien:',
    },
    {
      type: 'list',
      items: [
        'Los procesos internos de atención.',
        'Las funcionalidades de la plataforma.',
        'Los canales institucionales.',
        'La legislación o regulación aplicable.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'La versión vigente indicará su fecha de actualización y permanecerá disponible para consulta.',
    },
    {
      type: 'paragraph',
      text:
        'Las actualizaciones no afectarán desfavorablemente las solicitudes ya radicadas cuando ello implique desconocer derechos o garantías del usuario.',
    },
  ],

  normatividad: [
    {
      type: 'paragraph',
      text:
        'La recepción y gestión de las PQRSF se realizará conforme a la legislación colombiana y, según corresponda, a:',
    },
    {
      type: 'list',
      items: [
        'El régimen de protección de usuarios de servicios de comunicaciones.',
        'Las normas relacionadas con el derecho de petición.',
        'Las disposiciones sobre protección de datos personales.',
        'Las normas de protección al consumidor.',
        'Las condiciones contractuales del servicio.',
        'Las disposiciones que modifiquen, adicionen o sustituyan las anteriores.',
      ],
    },
    {
      type: 'paragraph',
      text:
        'En caso de contradicción entre estas condiciones y una disposición obligatoria, prevalecerá la norma legal o regulatoria aplicable.',
    },
  ],
};
